import React from "react";
import { getArrivalDayOffset } from "../../utilities/date";

/**
 * Displays arrival time with an optional +N superscript when arrival is on a later calendar day than departure.
 * `offsetDepartureDate` overrides the departure date used for the day-offset calculation (e.g. for return trips
 * where the shown arrival belongs to the return leg rather than the outbound departure).
 */
const ArrivalTime = ({ time, timeZone, departureDate, arrivalDate, departureTime, offsetDepartureDate, className }) => {
    if (!time || time === "tbc" || time === "TBC") {
        return time === "tbc" || time === "TBC" ? <>TBC</> : null;
    }

    const dayOffset = getArrivalDayOffset(offsetDepartureDate || departureDate, arrivalDate, departureTime, time);

    return (
        <span className={className}>
            {time}
            {dayOffset > 0 && (
                <sup className="arrival-time__day-offset" aria-label={`Arrives ${dayOffset} day${dayOffset > 1 ? "s" : ""} later`}>
                    +{dayOffset}
                </sup>
            )}
            {timeZone ? ` ${timeZone}` : ""}
        </span>
    );
};

export default ArrivalTime;
